import script from "./BrochureList.vue?vue&type=script&setup=true&lang=js"
export * from "./BrochureList.vue?vue&type=script&setup=true&lang=js"

import "./BrochureList.vue?vue&type=style&index=0&id=2dd23408&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dd23408"]])

export default __exports__